import { PROGRESS_START, PROGRESS_FINISH } from "../../mutation-types";
import reportApi from "../../../api/report";

const defaultState = () => ({
    dataPenjualan: [],
    pagination: {},
    detailPenjualan: {},
    rincianLaporan: [],
    productSelling: [],
    mitraBaru: []
});

const state = defaultState();

const getters = {
    buyerChartData() {
        let product = [
            ['Status', 'Qty', { role: "style" }]
        ]
        let color = ['#B831D2', '#F6A622']
        state.productSelling.forEach((element, index) => {
            product.push([element.product_name, parseInt(element.total), color[index]])
        });
        return product
    },
};

const mutations = {
    listDataPenjualan(state, data) {
        state.pagination = {}
        state.dataPenjualan = []
        state.rincianLaporan = []
        state.productSelling = []
        state.dataPenjualan = data.data;
        state.rincianLaporan = data.summary;
        state.productSelling = data.product;
        state.pagination = data.pagination;
    },
    listMitraBaru(state, data) {
        state.pagination = {}
        state.mitraBaru = []
        state.mitraBaru = data.data;
        state.pagination = data.pagination;
    },
    listDetailPenjualan(state, data) {
        state.detailPenjualan = data;
    },
};
const actions = {

    getLaporanPenjualan({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getTransactionData(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataPenjualan', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listDataPenjualan", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getTransactionData({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listDataPenjualan', { data: 'error', pagination: data.pagination, product: 'error', summary: 'error' });
                } else {
                    commit("listDataPenjualan", { data: data.results, pagination: data.pagination, product: data.product, summary: data.summary });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
    getDetailPenjualan({ commit }, params) {
        commit("listDetailPenjualan", {});
        commit(PROGRESS_START, null, { root: true });
        reportApi.getTransactionDetail(params).then(({ data: { data } }) => {
            commit("listDetailPenjualan", data);
            commit(PROGRESS_FINISH, null, { root: true });
        });
    },

    getMitraBaru({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        if (value.params.length > 0) {
            let parameterObject = {}
            let parameter = "{"
            value.params.forEach((value, index) => {
                for (const [key, val] of Object.entries(value)) {
                    parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`;
                }
            });
            parameter = parameter.slice(0, -1);
            parameter += `,"limit": "${value.limit}", "page": "${value.page}"`
            parameter += "}";
            parameterObject = JSON.parse(parameter);
            reportApi.getRegisterData(parameterObject).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listMitraBaru', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listMitraBaru", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        } else {
            reportApi.getRegisterData({ 'limit': value.limit, 'page': value.page }).then(({ data: { data } }) => {
                if (data.results.length == 0) {
                    commit('listMitraBaru', { data: 'error', pagination: data.pagination });
                } else {
                    commit("listMitraBaru", { data: data.results, pagination: data.pagination });
                }
                commit(PROGRESS_FINISH, null, { root: true });
            });
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};